import React from "react";
import {useSelector} from "react-redux";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {Container} from "@pg-design/grid-module";
import {calculateRemSize, flexAbsoluteCenter, flexDirection, mb, mt, w100} from "@pg-design/helpers-css";
import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../../app/rp_reducer";
import {articleListBoxTitle, ArticleListBoxWide} from "../../../article/components/article_list/ArticleListBoxWide";

export const PricesArticlesList = () => {
    const articles = useSelector((state: IRPStore) => state.report.price.articles);

    return (
        <Container css={mb(8)}>
            <Text variant="headline_2" align="center" css={mb(4)}>
                Raporty i analizy cenowe
            </Text>

            <div css={articlesWrapper}>
                {articles.map((article) => (
                    <ArticleListBoxWide
                        article={article}
                        key={article.id}
                        articleTitle={
                            <Text as="h3" variant="headline_4" css={articleListBoxTitle}>
                                {article.title}
                            </Text>
                        }
                        css={w100}
                    />
                ))}

                <Link href={rpAppLink.article.category({categorySlug: "raporty"})} target="_blank" size="inherit" css={linkStyle}>
                    <Button variant="filled_primary" type="button">
                        zobacz więcej
                    </Button>
                </Link>
            </div>
        </Container>
    );
};

const articlesWrapper = css`
    ${flexAbsoluteCenter};
    ${flexDirection("column")};
    gap: ${calculateRemSize(2)};
`;

const linkStyle = css`
    ${mt(4)};
`;
import React from "react";
import {useSelector} from "react-redux";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {Container} from "@pg-design/grid-module";
import {calculateRemSize, flexAbsoluteCenter, flexDirection, mb, mt, w100} from "@pg-design/helpers-css";
import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../../app/rp_reducer";
import {articleListBoxTitle, ArticleListBoxWide} from "../../../article/components/article_list/ArticleListBoxWide";

export const PricesArticlesList = () => {
    const articles = useSelector((state: IRPStore) => state.report.price.articles);

    return (
        <Container css={mb(8)}>
            <Text variant="headline_2" align="center" css={mb(4)}>
                Raporty i analizy cenowe
            </Text>

            <div css={articlesWrapper}>
                {articles.map((article) => (
                    <ArticleListBoxWide
                        article={article}
                        key={article.id}
                        articleTitle={
                            <Text as="h3" variant="headline_4" css={articleListBoxTitle}>
                                {article.title}
                            </Text>
                        }
                        css={w100}
                    />
                ))}

                <Link href={rpAppLink.article.category({categorySlug: "raporty"})} target="_blank" size="inherit" css={linkStyle}>
                    <Button variant="filled_primary" type="button">
                        zobacz więcej
                    </Button>
                </Link>
            </div>
        </Container>
    );
};

const articlesWrapper = css`
    ${flexAbsoluteCenter};
    ${flexDirection("column")};
    gap: ${calculateRemSize(2)};
`;

const linkStyle = css`
    ${mt(4)};
`;
